import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import CalendarBookingModal from '../CalendarBooking/CalendarBookingModal';
import { createIeltsRegistration } from '../../Services/Function';
import './NativeEventButton.css';

// Helper function to map English level to schema enum values
const mapEnglishLevel = (level) => {
  if (!level) return 'average';
  
  const levelLower = level.toLowerCase();
  if (levelLower.includes('weak') || levelLower.includes('poor') || levelLower.includes('beginner')) {
    return 'weak';
  } else if (levelLower.includes('excellent') || levelLower.includes('advanced') || levelLower.includes('fluent')) {
    return 'excellent';
  } else {
    return 'average';
  }
};

const NativeEventButton = ({ 
  text = "احجز موعد استشارة هاتفية مجانية",
  className = "banner-btn",
  variant = "primary",
  eventType = "IELTS",
  eventTitle = "استشارة IELTS مجانية",
  duration = 60,
  utm = {},
  ...props 
}) => {
  const [showCalendarModal, setShowCalendarModal] = useState(false);

  // Restrict to only October 15th, 2025 with single 4-6pm time slot
  const restrictedDate = new Date(2025, 9, 15); // Month is 0-indexed (9 = October)
  const restrictedTimeSlots = [
    { time: '16:00', available: true }  // 4:00 PM - 6:00 PM (single 2-hour slot)
  ];

  const handleClick = () => {
    setShowCalendarModal(true);
    
    // Track UTM parameters for analytics
    if (utm && Object.keys(utm).length > 0) {
      // Log UTM data for analytics
      console.log('Event button clicked with UTM:', utm);
      
      // You can send this to your analytics service
      // Analytics.track('event_button_clicked', utm);
    }
  };

  const handleBookingComplete = async (bookingData) => {
    console.log('Booking completed:', bookingData);
    
    // Add UTM data to booking
    const bookingWithUTM = {
      ...bookingData,
      utm: utm
    };
    
    try {
      // If this is an IELTS event, use the IELTS registration API
      if (eventType === "IELTS") {
        console.log('Raw booking data:', bookingData);
        console.log('Available booking data keys:', Object.keys(bookingData));
        
        // Validate required fields before sending
        const name = bookingData.name || bookingData.fullName || bookingData.firstName || "";
        const phone = bookingData.phoneNumber || bookingData.phone || "";
        const email = bookingData.email || "";
        const nationality = bookingData.nationality || "";
        
        console.log('Extracted values:', { name, phone, email, nationality });
        
        if (!name || name.trim().length < 2) {
          console.error('IELTS Registration Error: Name is required and must be at least 2 characters');
          alert('Please provide a valid name for IELTS registration. The calendar booking form needs to collect user information.');
          return;
        }
        
        if (!phone || !/^[+]?[0-9]{8,15}$/.test(phone.replace(/\s/g, ''))) {
          console.error('IELTS Registration Error: Valid phone number is required');
          alert('Please provide a valid phone number for IELTS registration. The calendar booking form needs to collect user information.');
          return;
        }
        
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          console.error('IELTS Registration Error: Valid email is required');
          alert('Please provide a valid email for IELTS registration. The calendar booking form needs to collect user information.');
          return;
        }
        
        if (!nationality || nationality.trim().length < 2) {
          console.error('IELTS Registration Error: Nationality is required');
          alert('Please provide nationality for IELTS registration. The calendar booking form needs to collect user information.');
          return;
        }
        
        const ieltsData = {
          name: name,
          age: bookingData.age || 25,
          phoneNumber: phone,
          email: email,
          nationality: nationality,
          studyDestination: bookingData.studyDestination === "UK" ? "uk" : "other",
          previousIELTS: bookingData.previousIELTS === "Yes" ? "yes" : "no",
          englishLevel: mapEnglishLevel(bookingData.englishLevel),
          fieldOfStudy: bookingData.fieldOfStudy || "Not specified",
          registrationTime: bookingData.time || new Date().toISOString(),
          guests: bookingData.guests || []
        };
        
        console.log('Processed IELTS data:', ieltsData);
        
        await createIeltsRegistration(ieltsData);
        
        console.log('IELTS registration completed successfully');
      }
      
      const googleSheetsService = (await import('../../Services/googleSheetsService')).default;
      
      // Save additional booking data with UTM to Google Sheets
      await googleSheetsService.saveBooking(bookingWithUTM);
      
      // Track successful booking for analytics
      googleSheetsService.trackBookingEvent('booking_completed', bookingWithUTM);
    } catch (error) {
      console.error('Failed to save booking with UTM data:', error);
    }
  };

  return (
    <>
      <Button
        variant={variant}
        className={`native-event-btn ${className}`}
        onClick={handleClick}
        {...props}
      >
        {text}
      </Button>

      {/* Calendar Booking Modal */}
      <CalendarBookingModal
        isOpen={showCalendarModal}
        onClose={() => setShowCalendarModal(false)}
        eventType={eventType}
        eventTitle={eventTitle}
        duration={duration}
        onBookingComplete={handleBookingComplete}
        restrictedDate={restrictedDate}
        restrictedTimeSlots={restrictedTimeSlots}
      />
    </>
  );
};

export default NativeEventButton;
